import { createStore } from "zustand/vanilla";

export type GlobalState = {
  isLoginModalOn: boolean;
  isDrawerOpen: boolean;
  previousPathname: string | null;
  discountCode: string;
};

export type GlobalAction = {
  setIsLoginModalOn: (value: GlobalState["isLoginModalOn"]) => void;
  setDiscountCode: (value: GlobalState["discountCode"]) => void;
  setIsDrawerOpen: (value: GlobalState["isDrawerOpen"]) => void;
  setPreviousPathname: (value: GlobalState["previousPathname"]) => void;
};

export type GlobalStore = GlobalState & GlobalAction;

const defaultState: GlobalState = {
  isLoginModalOn: false,
  discountCode: "",
  isDrawerOpen: false,
  previousPathname: null,
};

export const createGlobalStore = (initState: GlobalState = defaultState) =>
  createStore<GlobalStore>((set) => ({
    ...defaultState,
    setIsLoginModalOn: (isLoginModalOn) => set(() => ({ isLoginModalOn })),
    setDiscountCode: (discountCode) => set(() => ({ discountCode })),
    setIsDrawerOpen: (isDrawerOpen) => set(() => ({ isDrawerOpen })),
    setPreviousPathname: (previousPathname) =>
      set(() => ({ previousPathname })),
  }));
